import { render, staticRenderFns } from "./PaymentStatementView.vue?vue&type=template&id=f0445bd8&scoped=true"
import script from "./PaymentStatementView.vue?vue&type=script&lang=js"
export * from "./PaymentStatementView.vue?vue&type=script&lang=js"
import style0 from "./PaymentStatementView.vue?vue&type=style&index=0&id=f0445bd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0445bd8",
  null
  
)

export default component.exports